import styled from 'styled-components';

export const TextBox = styled.div`
  overflow: hidden;

  ul {
    padding-left: 20px;

    li {
      margin: 5px 0;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 15px 0;
  }

  dt {
    margin: 15px 0 0;
  }

  dd,
  p {
    margin: 15px 0;
  }

  @media print {
    max-height: none !important;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  bottom: -1px;
  width: 100%;
  height: 80px;
  padding: 50px 5px 5px 5px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 100%);

  button {
    font-size: 14px;
  }
`;
